const NUMBERS = ["0808 2000 247", "0800 0086 811", "0300 123 6600", "0300 123 1110", "0800 358 3456", "0300 888 3853", "020 7498 4680", "0808 808 7777", "0800 1111", "116 123", "85258", "999", "111"];
const RE = new RegExp(`(?<![\\d.])(${NUMBERS.map((n) => n.replace(/ /g, "\\s")).join("|")})(?!\\d|\\.\\d)`, "g");

export const Linkify = ({ text }) => {
  if (!text) return null;
  return text.split(RE).map((part, i) => {
    if (i % 2 === 0) return part;
    const digits = part.replace(/\D/g, "");
    const href = digits === "85258" ? "sms:85258?body=SHOUT" : `tel:${digits}`;
    return <a key={i} href={href} className="font-semibold underline underline-offset-2" data-testid={`tel-link-${digits}`}>{part}</a>;
  });
};
